import styled from 'styled-components';
import { QuestType } from '@typings/quest/questTypes';

export const Section = styled.div``;

export const SectionTitle = styled.h6`
  color: var(--subTextColor);
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 4px;
`;

export const RewardsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const RewardItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: var(--cardBackgroundColor);
  border: 1px solid var(--lineColor);
  border-radius: 8px;
  gap: 12px;
`;

export const RewardIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background-color: var(--primaryColor);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const RewardInfo = styled.div`
  flex: 1;
`;

export const RewardName = styled.div`
  font-weight: 500;
  color: var(--textColor);
  margin-bottom: 2px;
  word-break: keep-all;
`;

export const RewardAmount = styled.div`
  color: var(--subTextColor);
  font-size: 0.875rem;
`;

export const MetaInfoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
`;

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: var(--cardBackgroundColor);
  border: 1px solid var(--borderColor);
  border-radius: 8px;
  font-size: 0.875rem;
`;

export const MetaLabel = styled.span`
  color: var(--subTextColor);
`;

export const MetaValue = styled.span`
  color: var(--textColor);
  font-weight: 500;
`;

export const QuestTypeBadge = styled.span<{ questType: QuestType }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  height: fit-content;
  font-weight: 600;
  background-color: ${(props) =>
    props.questType === QuestType.MAIN
      ? 'var(--buttonBackgroundColor)'
      : props.questType === QuestType.MEMBER_REQUEST
        ? 'var(--primaryColor, #7c3aed)'
        : 'var(--subColor)'};
  color: ${(props) =>
    props.questType === QuestType.MAIN
      ? 'var(--buttonTextColor)'
      : props.questType === QuestType.MEMBER_REQUEST
        ? 'var(--textColor)'
        : 'var(--subTextColor)'}; ;
`;

export const RequesterInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ConditionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--textColorLight);
`;
